import React from 'react';

import PropTypes from 'prop-types';
import {
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';

  

const AssessmentTableHead = (props)=> {

  const {t, i18n} = useTranslation();

  const columns = [
      {
        id:'date',
        numeric:true,
        disablePadding:false,
        label:t('date',{ns:'asmttablehead'})
      },
      {
        id:'status',
        numeric:false,
        disablePadding: false,
        label: t('status',{ns:'asmttablehead'})
      },
      {
        id:'report',
        numeric:false,
        disablePadding: false,
        label:t('report',{ns:'asmttablehead'})
      } ,
      {
        id:'video',
        numeric:false,
        disablePadding: false,
        label:t('video',{ns:'asmttablehead'})
      },
      {
        id:'restart',
        numeric:false,
        disablePadding: false,
        label:t('commands',{ns:'asmttablehead'})
      }
    ];

    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount
    } = props;
  
    const createSortHandler = property => event => {
      props.onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
        
          {columns.map(
            (column, index) => (
              <TableCell
                align={column.numeric ? 'center' : 'left'}
                key={column.id}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
                style={index === 0 ? {
                  position: 'sticky',
                  left: 0,
                  backgroundColor: '#f5f5f5',
                  zIndex: 3,
                  boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
                  borderRight: '2px solid #e0e0e0',
                  fontWeight: 600
                } : {}}
              >
                <Tooltip
                  enterDelay={300}
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  title="Sort"
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    );
  };
  
  AssessmentTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
  };
  export default AssessmentTableHead;